import { useEffect } from 'react';
import { SESSION_DURATION } from "../../../eschool_UI/src/pages/constants";

//const SESSION_DURATION = (60 * 60 * 1000) * 4; // 4 hours

const useSlidingSession = () => {
    useEffect(() => {
        const updateSessionExpiry = () => {
            const token = localStorage.getItem('token');
            if (token) {
                const newExpiry = Date.now() + SESSION_DURATION;
                localStorage.setItem('session_expiry', newExpiry.toString());
               // console.log("🔥 Session extended:", new Date(newExpiry));
            }
        };

        const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];
        events.forEach(event => window.addEventListener(event, updateSessionExpiry));

        updateSessionExpiry(); // run on first mount

        return () => {
            events.forEach(event => window.removeEventListener(event, updateSessionExpiry));
        };
    }, []);
};

export default useSlidingSession;
